import React from 'react'
import * as UI from 'ui'
import { SpaceBetween } from 'ui'
import * as Displays from 'support/displays'
import { Translation, Translator } from '@morningtrain/react-translations'
import Widget from 'widgets/Widget'
import {ForEachModel, Model, ValueToCollection, WhenModel} from '@morningtrain/react-resources'
import { SelectedDepartmentFilter } from 'support/filters'
import CardSummarySection from 'widgets/economy/partials/CardSummarySection'
import { Link } from '@morningtrain/react-navigation'
import SmartviewTextGroup from 'widgets/smartviews/partials/SmartviewTextGroup'
import SmartviewText from 'widgets/smartviews/partials/SmartviewText'
import SmartviewContentSeparator from 'widgets/smartviews/partials/SmartviewContentSeparator'
import CookieFilter from "support/filters/CookieFilter";
import {Env} from "@morningtrain/helpers";

export default function AverageBasketSizeEconomyWidget () {
  const hasMultipleTakeaway = Env.get('globals.has_multiple_takeaway');
  const basketSize = Env.get('globals.has_calculated_basket_size') === false ? 'average_basket_size' :
    'average_basket_size_calculated';

  return (
    <Widget>
      <Translator namespace='economy.average_basket_size'>
        <UI.Card paddingBottom={false}>
          <SpaceBetween>
            <UI.Text weight='medium' size='lg'>
              <Translation name='title' />
            </UI.Text>
            <Link route='app.economy.avg_basket_size'>
              <UI.Button color='lightgray'>
                <Translation name='view_all' />
              </UI.Button>
            </Link>
          </SpaceBetween>

          <Model resourceName='economy'
                 operationName={basketSize}
          >
            <CookieFilter name='period' cookieKey='page.filters.period' />
            <SelectedDepartmentFilter />

            <WhenModel>
              <div className='flex flex-col flex-grow flex-shrink pt-6'>

                <UI.Text weight='medium' size='3xl'>
                  <Displays.Currency name='average_basket_size' decimals={0} />
                </UI.Text>

                <UI.Text weight='light' size='xs' color='gray' className='w-4/5'>
                  <Translation name='change' data={{ change: 'model:change|0', days: 'model:period_duration|0' }} />
                </UI.Text>

                <SmartviewContentSeparator className='mb-8 mt-4' />

                <SmartviewTextGroup highlight highlightSize='card'>

                  <SmartviewText>
                    <UI.SpaceBetween>
                      <UI.Text size='base'>
                        <Translation name='generic.inhouse' />
                      </UI.Text>
                      <UI.Text weight='medium' size='base' align='right' color='black'>
                        <Displays.Currency name='inhouse_this_period' decimals={0} />
                      </UI.Text>
                    </UI.SpaceBetween>
                  </SmartviewText>

                  {
                    !hasMultipleTakeaway ?
                      <SmartviewText>
                      <UI.SpaceBetween>
                        <UI.Text size='base'>
                          <Translation name='generic.takeaway' />
                        </UI.Text>
                        <UI.Text weight='medium' size='base' align='right' color='black'>
                          <Displays.Currency name='takeaway_this_period' decimals={0} />
                        </UI.Text>
                      </UI.SpaceBetween>
                    </SmartviewText> : false
                  }

                  {hasMultipleTakeaway ?
                    <ValueToCollection name='takeaways_this_period'>
                      <ForEachModel>
                        <SmartviewText>
                          <UI.SpaceBetween>
                            <UI.Text size='base'>
                              <Displays.Text name='name' />
                            </UI.Text>
                            <UI.Text weight='medium' size='base' align='right' color='black'>
                              <Displays.Currency name='value' decimals={0} />
                            </UI.Text>
                          </UI.SpaceBetween>
                        </SmartviewText>
                      </ForEachModel>
                    </ValueToCollection> : false }

                </SmartviewTextGroup>

              </div>

            </WhenModel>

            <UI.HorizontalList border className='my-4 pt-6 -mx-8'>
              <CardSummarySection />
            </UI.HorizontalList>
          </Model>

        </UI.Card>
      </Translator>
    </Widget>
  )
}
